<template>
    <el-dialog
            title="变更审核"
            :visible="true"
            :append-to-body=true
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="审核:">
               <!-- <el-switch v-model="form.code"></el-switch>-->
                <el-radio v-model="form.code" label="2">审核通过</el-radio>
                <el-radio v-model="form.code" label="3">审核不通过</el-radio>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="save()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "edit",
        data(){
            return {
                form:{
                    code:false
                }
            }
        },
        props:{
            pushData:{
                type:Object,
                default:function(){
                    return;
                }
            }

        },
        methods:{
            save(){
                let url = '/returngoods/' + this.pushData.return_goods_sn +'/verify',status='';
                this.$patch('logistics',url, {
                    lang:'',
                    _method:'PATCH',
                    returngoods:this.pushData.return_goods_sn,
                    verify_status:this.form.code
                }).then(res => {
                    if(res.message =='操作成功'){
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.$emit('refresh');
                        this.$emit('handleClose');
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            //this.form.code = this.pushData.verify_status;
            /*if(this.pushData.verify_status == 3){
                this.form.code = false;
            }else{
                this.form.code = true;
            }*/
        }
    }
</script>

<style scoped>

</style>